import { Box, Button } from "@mui/material";
import React from "react";
import { HighlightSelectBox } from "../highLightSelectBox";
import { AssociationObjectDetails, SelectBoxOption } from "../../interfaces";
import { DtTemplateType, useGetAllDataTableDDOptionsQuery } from "../../redux/services";

export const LinkUnlinkDocumentTemplate: React.FC<{
    dtType: DtTemplateType,
    multiple: boolean,
    objectId?: string,
    objectType?: string,
    documentTemplates: AssociationObjectDetails[] | AssociationObjectDetails | null,
    onUpdate: (itemsAdded: AssociationObjectDetails[], itemsRemoved: AssociationObjectDetails[]) => void
}> = ({
    dtType = 'checklist',
    multiple = false,
    documentTemplates = [],
    onUpdate = (itemsAdded, itemsRemoved) => false
}) => {

        const dtTemplateData = useGetAllDataTableDDOptionsQuery({ dtTemplateType: dtType })

        const [dtStack, setDTStack] = React.useState<AssociationObjectDetails[] | AssociationObjectDetails | null>(documentTemplates);

        const onUpdateBtnClicked = () => {
            if (multiple && Array.isArray(documentTemplates) && Array.isArray(dtStack)) {
                let currentItemIds = dtStack.map(i => i._id);
                let removedItems = documentTemplates.filter(i => !currentItemIds.includes(i._id));
                onUpdate(dtStack, removedItems);
            } else {
                onUpdate([dtStack as AssociationObjectDetails], []);
            }
        };

        return <Box>
            <HighlightSelectBox
                size="medium"
                margin="none"
                multiple={multiple}
                options={dtTemplateData?.data ?? []}
                label={'Template'}
                value={dtStack as unknown as SelectBoxOption[]}
                onChange={(option: any) => setDTStack(option as AssociationObjectDetails[])}
                loading={dtTemplateData.isLoading || dtTemplateData.isFetching}
                error={dtTemplateData.isError}
                helperText={dtTemplateData.isError ? "Something went wrong, Unable to fetch document templates." : ""}
            />

            <Button
                fullWidth
                variant="contained"
                sx={{ marginTop: 2 }}
                onClick={(e) => onUpdateBtnClicked()}
            >Update</Button>
        </Box>
    }